import { useEffect, useState } from 'react'
import _ from 'lodash'
import { Col, Row } from 'antd'
import clx from 'classnames'
import { retrieveQueryParams } from '@vzmi/component_ec_nodejs_util/dist/lib/HistoryUtil'
import { FormLoader, ProposalBlock } from '@vzmi/shp_shared_compo'
import { httpHandler, safeAwait } from '@vzmi/component_ec_nodejs_util/dist/lib/FetchDataUtil'
import errorHelper from '../../../../lib/errorHelper'
import { withCommonPageErrorBoundary } from '../../Common/HOC/withErrorBoundary'
import { HyperLink } from '../../Common/Form'
import ContentLayout from '../../BatchProposal/Common/ContentLayout'
import HeadingWithId from '../../Proposal/Common/HeadingWithId/HeadingWithId'
import styles from './index.css'

const BackToHomeLink = () => (
  <HyperLink href='/'>
    回首頁
  </HyperLink>
)

const useKeyword = (actions, displayName) => {
  const [isLoaded, setIsLoaded] = useState(false)
  const [keyword, setKeyword] = useState()

  useEffect(() => {
    if (_.isEmpty(displayName) || !_.isEmpty(keyword)) {
      return
    }
    const getKeyword = async () => {
      const { fetchBadWords, setNotFound } = actions
      const query = {
        displayName,
        fullMatch: true
      }
      const [error, data] = await safeAwait(fetchBadWords(query).then(httpHandler))
      if (error) {
        const errorMessage = errorHelper.parseErrorMessage(error)
        setNotFound(errorMessage)
        return
      }

      const badWord = _.get(data, 'badWords[0]', [])
      setIsLoaded(true)
      if (_.isEmpty(badWord)) {
        setNotFound()
        return
      }

      setKeyword(badWord)
    }
    getKeyword()
  }, [actions, displayName, keyword])

  return { isLoaded, keyword }
}

const KeywordQuery = (props) => {
  const { actions } = props
  const { displayName = '' } = retrieveQueryParams()
  const { isLoaded, keyword } = useKeyword(actions, displayName)
  const description = _.get(keyword, 'description', '')

  return (
    <ContentLayout>
      <ProposalBlock className={styles.keywordBlock}>
        <FormLoader
          isLoading={!isLoaded}
          fixed
        >
          <Row
            justify='center'
          >
            <HeadingWithId
              title={`內容含有不合法文字：${displayName}`}
            />
            <Col
              span={24}
              className={clx(styles.keywordDesc, 'card-container')}
            >
              <Row justify='center'>
                <pre>
                  {description}
                </pre>
              </Row>
            </Col>
          </Row>
        </FormLoader>
      </ProposalBlock>
    </ContentLayout>
  )
}

const hoc = _.flow([
  // common page: yahoo title & supplier part
  // error boundary
  withCommonPageErrorBoundary(<BackToHomeLink />)
])

export default hoc(KeywordQuery)
